const initialState = {
    calls: {},
    isReadingCalls: false,
    isHangingUp: false,
    
    incomingCalls: [],
    recentCalls: [],
    numberOfConferenceRooms: 0,
    departments: [],
    extensions: {},
    queues: [],
    callerInActionsView: null,
    actionsViewVisible: false,
    isActiveCall: false,

    selectedTeamsTab: "pinned",
    currentCall: null,
    isReadingCreds: false,
    creds: {},
    callState: 'idle',
    contactLeg: null, 
    userLeg: null,
    currentPBX: null,
    pbx: null,
    endedCalls: {},
    currentCallPhoneNumber: null,
    callDirection: null,
    isIgnore: false,
    selectedTab: 0,
    islookingupUser: false,

}

export default initialState;
